import {useMemo, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectBackgrounds} from '~/CreateFabricGreetingCard/reducers/fabricTemplate/selectors';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {selectBackgroundId} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {isAllowedVideoFormat} from '~/common/fabric/utils';

export const useBackground = (isMobile = false) => {
  const dispatch = useDispatch();
  const backgrounds = useSelector(selectBackgrounds);
  const backgroundId = useSelector(selectBackgroundId);

  const backgroundIcons = useMemo(
    () =>
      backgrounds
        ?.filter(({media}) => media.find(({label}) => label === 'desktop').url)
        ?.map(({media}) => media.find(({label}) => label === 'icon').url),
    [backgrounds]
  );

  const onColorChange = useCallback((background) => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {
        backgroundColor: background,
        backgroundId: null,
        premiumFeaturesPristine: false,
        pristineBackground: false,
      },
    });
  }, []);

  const onTextureChange = useCallback(
    (icon) => {
      const selected = backgrounds.find(
        ({media}) => media.find(({label}) => label === 'icon').url === icon
      );
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {
          backgroundId: selected.id,
          backgroundColor: null,
          premiumFeaturesPristine: false,
          pristineBackground: false,
        },
      });
    },
    [backgrounds]
  );

  const selectedBackground = useMemo(() => {
    const selected = backgrounds?.find(({id}) => id === backgroundId);
    if (selected) {
      const mode = isMobile ? 'mobile' : 'desktop';
      const src = selected.media.find(({label}) => label === mode).url;
      const icon = selected.media.find(({label}) => label === 'icon').url;
      const isVideo = isAllowedVideoFormat(src);
      return {...selected, src, icon, isVideo};
    }
    return undefined;
  }, [backgrounds, backgroundId]);

  return {backgroundIcons, onColorChange, onTextureChange, selectedBackground};
};
